import Button from "../../Shared/Button/Button";

const ReviewOptions = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-1.5 border-l border-lightGray">
      <Button text="View Item" variant="secondary" />
      <Button text="View Review" variant="blue" />
      <Button text="Buyer Info" variant="outline" />
      <p className="font-pop text-[13px] font-bold text-darkGreen">
        From: <span className="font-medium text-secondary">Pro_bidder</span>
      </p>
    </div>
  );
};

export default ReviewOptions;
